/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LookupVMIEnumerableResponseVM } from '../models/LookupVMIEnumerableResponseVM';
import type { PayeeAccountVM } from '../models/PayeeAccountVM';
import type { PayeeAccountVMIEnumerableResponseVM } from '../models/PayeeAccountVMIEnumerableResponseVM';
import type { PayeeAccountVMResponseVM } from '../models/PayeeAccountVMResponseVM';
import type { PaymentDueAccountVM } from '../models/PaymentDueAccountVM';
import type { PaymentDueAccountVMIEnumerableResponseVM } from '../models/PaymentDueAccountVMIEnumerableResponseVM';
import type { PaymentDueAccountVMResponseVM } from '../models/PaymentDueAccountVMResponseVM';
import type { PaymentMethodVM } from '../models/PaymentMethodVM';
import type { PaymentMethodVMIEnumerableResponseVM } from '../models/PaymentMethodVMIEnumerableResponseVM';
import type { PaymentMethodVMResponseVM } from '../models/PaymentMethodVMResponseVM';
import type { PayPaymentDueAccountVM } from '../models/PayPaymentDueAccountVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentService {
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PayeeAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPayeeAccountOrganizationlist(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PayeeAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PayeeAccount/{organizationId}/organizationlist',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PayeeAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPayeeAccountTenantlist(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PayeeAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PayeeAccount/{tenantId}/tenantlist',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PayeeAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPayeeAccountContractorlist(
        contractorId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PayeeAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PayeeAccount/{contractorId}/contractorlist',
            path: {
                'contractorId': contractorId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param userId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PayeeAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPayeeAccountUserlist(
        userId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PayeeAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PayeeAccount/{userId}/userlist',
            path: {
                'userId': userId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param payeeAccountId
     * @returns PayeeAccountVMResponseVM Success
     * @throws ApiError
     */
    public static getApiPayeeAccount(
        payeeAccountId: number,
    ): CancelablePromise<PayeeAccountVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PayeeAccount/{payeeAccountId}',
            path: {
                'payeeAccountId': payeeAccountId,
            },
        });
    }
    /**
     * @param payeeAccountId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiPayeeAccount(
        payeeAccountId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/PayeeAccount/{payeeAccountId}',
            path: {
                'payeeAccountId': payeeAccountId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PayeeAccountVMResponseVM Success
     * @throws ApiError
     */
    public static postApiPayeeAccount(
        requestBody?: PayeeAccountVM,
    ): CancelablePromise<PayeeAccountVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PayeeAccount',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PayeeAccountVMResponseVM Success
     * @throws ApiError
     */
    public static putApiPayeeAccount(
        requestBody?: PayeeAccountVM,
    ): CancelablePromise<PayeeAccountVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/PayeeAccount',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns LookupVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPayeeAccountOrganizationlookup(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<LookupVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PayeeAccount/{organizationId}/organizationlookup',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentDueAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccountOrganizationlist(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentDueAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{organizationId}/organizationlist',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentDueAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccountTenantlist(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentDueAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{tenantId}/tenantlist',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentDueAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccountPropertylist(
        propertyId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentDueAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{propertyId}/propertylist',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param unitId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentDueAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccountUnitlist(
        unitId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentDueAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{unitId}/unitlist',
            path: {
                'unitId': unitId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param userId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentDueAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccountUserlist(
        userId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentDueAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{userId}/userlist',
            path: {
                'userId': userId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param contractorId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentDueAccountVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccountContractorlist(
        contractorId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentDueAccountVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{contractorId}/contractorlist',
            path: {
                'contractorId': contractorId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param paymentId
     * @returns PaymentDueAccountVMResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentDueAccount(
        paymentId: number,
    ): CancelablePromise<PaymentDueAccountVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentDueAccount/{paymentId}',
            path: {
                'paymentId': paymentId,
            },
        });
    }
    /**
     * @param paymentId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiPaymentDueAccount(
        paymentId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/PaymentDueAccount/{paymentId}',
            path: {
                'paymentId': paymentId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PaymentDueAccountVMResponseVM Success
     * @throws ApiError
     */
    public static postApiPaymentDueAccount(
        requestBody?: PaymentDueAccountVM,
    ): CancelablePromise<PaymentDueAccountVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PaymentDueAccount',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PaymentDueAccountVMResponseVM Success
     * @throws ApiError
     */
    public static putApiPaymentDueAccount(
        requestBody?: PaymentDueAccountVM,
    ): CancelablePromise<PaymentDueAccountVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/PaymentDueAccount',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static putApiPaymentDueAccountPay(
        requestBody?: PayPaymentDueAccountVM,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/PaymentDueAccount/pay',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentMethodVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentMethodOrganizationlist(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentMethodVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentMethod/{organizationId}/organizationlist',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param propertyId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentMethodVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentMethodPropertylist(
        propertyId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentMethodVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentMethod/{propertyId}/propertylist',
            path: {
                'propertyId': propertyId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param unitId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentMethodVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentMethodUnitlist(
        unitId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentMethodVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentMethod/{unitId}/unitlist',
            path: {
                'unitId': unitId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param tenantId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns PaymentMethodVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentMethodTenantlist(
        tenantId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<PaymentMethodVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentMethod/{tenantId}/tenantlist',
            path: {
                'tenantId': tenantId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param paymentId
     * @returns PaymentMethodVMResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentMethod(
        paymentId: number,
    ): CancelablePromise<PaymentMethodVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentMethod/{paymentId}',
            path: {
                'paymentId': paymentId,
            },
        });
    }
    /**
     * @param paymentId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiPaymentMethod(
        paymentId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/PaymentMethod/{paymentId}',
            path: {
                'paymentId': paymentId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PaymentMethodVMResponseVM Success
     * @throws ApiError
     */
    public static postApiPaymentMethod(
        requestBody?: PaymentMethodVM,
    ): CancelablePromise<PaymentMethodVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/PaymentMethod',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PaymentMethodVMResponseVM Success
     * @throws ApiError
     */
    public static putApiPaymentMethod(
        requestBody?: PaymentMethodVM,
    ): CancelablePromise<PaymentMethodVMResponseVM> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/PaymentMethod',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns LookupVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiPaymentMethodOrganizationlookup(
        organizationId: number,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<LookupVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/PaymentMethod/{organizationId}/organizationlookup',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
}
